export { App as default } from '@guiker/rental-tenancy-main-mfe'
